import {BaseCarrierUiExtension} from "./baseCarrierUiExtension";

export class DostavistaCarrierUiExtension extends BaseCarrierUiExtension {
    usePrimaryPhoneOnly() {
        return true;
    }

    getPhoneHintText() {
        return 'Мобильный телефон контактного лица. При необходимости, дополнительные номера телефонов просим указывать в полях комментариев к адресам отправления/ доставки';
    }

    moveExtraPhonesToAddressComments(form) {
        if (!form) {
            return null;
        }

        const patch = {};
        const sides = ['shipment', 'delivery'];

        sides.forEach((side) => {
            const ext1 = (form[`${side}Ext1`] || '').trim();
            const ext2 = (form[`${side}Ext2`] || '').trim();
            const additionalPhone = (form[`${side}AdditionalPhone`] || '').trim();
            const legacyAdditional = (form[`${side}Additional`] || '').trim();

            const details = [];
            if (ext1) {
                details.push(`добавочный к основному: ${ext1}`);
            }
            if (additionalPhone) {
                details.push(`доп. телефон: ${additionalPhone}`);
            }
            if (ext2) {
                details.push(`добавочный к доп. телефону: ${ext2}`);
            }
            if (legacyAdditional && legacyAdditional !== ext1) {
                details.push(`добавочный: ${legacyAdditional}`);
            }

            if (details.length > 0) {
                const currentComment = (form[`${side}AddressComment`] || '').trim();
                const detailsText = `Доп. контакты: ${details.join('; ')}`;
                patch[`${side}AddressComment`] = currentComment
                    ? `${currentComment}. ${detailsText}`
                    : detailsText;

                patch[`${side}Ext1`] = '';
                patch[`${side}Ext2`] = '';
                patch[`${side}AdditionalPhone`] = '';
                patch[`${side}Additional`] = '';
            }
        });

        return Object.keys(patch).length > 0 ? patch : null;
    }

    isCourierMessageAvailable() {
        return true;
    }

    onTariffSelected({selectedTariff, changeParam}) {
        changeParam('vehicleTypeId', selectedTariff ? selectedTariff.vehicleTypeId : null);
    }
}




// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/carrierExtensions/dostavistaCarrierUiExtension.js